const formatTime = (timeValue) => {
	if (timeValue === null || timeValue === undefined || timeValue === "") {
		return "";
	}

	const isTimestamp =
		typeof timeValue === "number" ||
		(typeof timeValue === "string" && /^\d+$/.test(timeValue.trim()));

	let normalizedTime = String(timeValue);

	if (isTimestamp) {
		const numericValue = Number(timeValue);
		const timestamp =
			String(Math.trunc(numericValue)).length === 10
				? numericValue * 1000
				: numericValue;

		const date = new Date(timestamp);
		if (Number.isNaN(date.getTime())) {
			return "";
		}

		normalizedTime = date.toLocaleTimeString("en-US");
	}

	const splitTimeString = normalizedTime.split(":");
	if (splitTimeString.length < 2) {
		return normalizedTime;
	}

	return `${splitTimeString[0]}:${splitTimeString[1]}`;
};

export default formatTime;
